import { paths } from "helpers/paths";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import List from "./list";

export default class DistributionBidSources extends Component {
    componentWillUnmount() {
        this.props.clearParams("distribution-bid-sources");
    }

    render() {
        const { match, location, history } = this.props;
        const rootUrl = `${match.path}/list`;
        const back = () => history.push(paths.dictionaries);
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => (
                            <List
                                {...this.props}
                                isTable
                                transition="full"
                                title="Источники внешних заказов"
                                nofilter
                                back={back}
                            />
                        )}
                    />
                </Switch>
            </div>
        );
    }
}
